import React from 'react';

import map from 'lodash/map';
import isEmpty from 'lodash/isEmpty';

import Hidden from '@material-ui/core/Hidden';
import { withStyles } from '@material-ui/core/styles';

import NavLink from '../../../NavLink';
import RichMenuItem from './components/RichMenuItem';

const styles = () => ({
  link: {
    textDecoration: 'none',
    marginRight: '27px',
    color: '#2a149a',
    fontSize: '14px',
    fontFamily: 'Raleway',
    fontWeight: 'normal',
  },
  activeLink: {
    fontWeight: 'bold',
  },
});

const Entries = ({ classes, items }) => {
  return (
    <>
      {map(items, (item, index) => {
        const hasSubmenu = !isEmpty(item.submenu);

        return hasSubmenu ? (
          <Hidden smDown key={`topbar-item-${index}`}>
            <RichMenuItem
              key={`rich-menu-item-${index}`}
              className={classes.link}
              {...item}
            />
          </Hidden>
        ) : (
          <Hidden smDown key={`topbar-item-${index}`}>
            <NavLink
              key={`menu-item-${index}`}
              to={item.url}
              className={classes.link}
              activeClassName={classes.activeLink}
            >
              {item.name}
            </NavLink>
          </Hidden>
        );
      })}
    </>
  );
};

export default withStyles(styles)(Entries);
